import React, { useEffect } from "react";
import getCompanyDatahubType, {
  GetCompanyDatahubTypeResult,
  GetCompanyDatahubTypeVariables,
} from "../graphqlQueries/getCompanyDatahubType";
import {
  getHasuraRoleContext,
  isCompanyDmo,
  isDmoOrRequestedDmo,
  isTravelCompany,
  isUserWithoutOrganisation,
  isVisitFinlandAdmin,
} from "../utils/functions";

import NoOrganisationDashboard from "../components/dashboard/NoOrganisationDashboard";
import { DMODashboardWrapper } from "../components/dashboard/DMODashboardWrapper";
import Page from "./Page";
import { TCDashboard } from "../components/dashboard/TCDashboard";
import { UserRole } from "../types";
import VFAdminDashboard from "../components/dashboard/VFAdminDashboard";
import { useKeycloak } from "@react-keycloak/web";
import { useLazyQuery } from "@apollo/client";
import { userInfoVar } from "../utils/ApolloCache";
import DefaultDashboard from "../components/dashboard/DefaultDashboard";

type DashboardProps = {
  companyId?: string;
};

const Dashboard: React.FunctionComponent<DashboardProps> = ({ companyId }) => {
  const { keycloak } = useKeycloak();
  const userInfo = userInfoVar();

  const [getCompanyDatahubTypeQuery, { data: companyData }] = useLazyQuery<
    GetCompanyDatahubTypeResult,
    GetCompanyDatahubTypeVariables
  >(getCompanyDatahubType, {
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (companyId) {
      void getCompanyDatahubTypeQuery({
        context: getHasuraRoleContext(UserRole.ViewCompany),
        variables: {
          companyId: companyId,
        },
      });
    }
  }, [getCompanyDatahubTypeQuery, companyId]);

  const getDashboard = () => {
    if (isVisitFinlandAdmin(keycloak)) {
      return <VFAdminDashboard />;
    } else if (
      isDmoOrRequestedDmo(keycloak) &&
      isCompanyDmo(companyData?.companyByPk?.datahubType)
    ) {
      return companyId ? <DMODashboardWrapper companyId={companyId} /> : null;
    } else if (isTravelCompany(keycloak)) {
      return companyId ? <TCDashboard companyId={companyId} /> : null;
    } else if (isUserWithoutOrganisation(userInfo)) {
      return <NoOrganisationDashboard />;
    } else {
      return <DefaultDashboard />;
    }
  };

  return <Page>{getDashboard()}</Page>;
};

export default Dashboard;
